import React from "react";
import styled from "styled-components";
import { Card, InputField, PageTitle } from "../../../../v2/design-system";
import { theme } from "../../../../v2/design-system/theme";
import { HubFieldCell, HubFieldGrid, HubMutedText } from "../societyHubShell";

const Inner = styled.div`
  padding: ${theme.spacing.xl};
`;

const UserBasicDetails = ({ user }) => {
  const formFields = [
    { key: "firstName", label: "First Name", width: 6 },
    { key: "lastName", label: "Last Name", width: 6 },
    { key: "status", label: "Status", width: 6 },
    { key: "mobileNo", label: "Phone Number", width: 6 },
  ];

  if (!user) {
    return <HubMutedText>Loading user details…</HubMutedText>;
  }

  return (
    <Card style={{ overflow: "hidden" }}>
      <Inner>
        <PageTitle style={{ marginBottom: theme.spacing.lg }}>User Basic Details</PageTitle>
        <HubFieldGrid>
          {formFields.map((field) => {
            let value = user?.[field.key] || "";
            if (field.key === "status" && value) {
              value = value.toUpperCase();
            }
            return (
              <HubFieldCell key={field.key} $span={field.width}>
                <InputField label={field.label} value={value} readOnly disabled />
              </HubFieldCell>
            );
          })}
        </HubFieldGrid>
      </Inner>
    </Card>
  );
};

export default UserBasicDetails;
